import axios from "../../../axios"
import { getCurrentTenant, parseObjectParamsToString } from '@/utils'

export default {
  fetch() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query { 
          stockImages {
            id,
            user_id,
            url,
            caption,
            description
          }
        }
      `
    })
  },
  add(params) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createStockImage ${parseObjectParamsToString(params)} {
            id,
            user_id,
            url,
            caption,
            description,
          }
        }
      `
    })
  },
  delete(id) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteStockImage (
            id: ${id}
          )
        }
      `
    })
  }
}
